module.exports = "/_next/static/videos/aboutCompanyDesktopVideo-31a830810bae90d43d885312136c2994.mp4";